export default __webpack_public_path__ + "media/zurb/img/legacy/axe/6-dfe5d2884375e1509785873d45267c47.jpg";